<template>
<v-container fluid>
  <div class="page-shell">
    <notification-dialog></notification-dialog>
    <filter-form-income/>
    <dialog-form-income/>
    <form-analysis/>
    <v-card class="page-card">
      <v-toolbar color="primary" class="page-toolbar">
        <v-toolbar-title>Entradas</v-toolbar-title>
        <v-btn v-if="canCreate" color="white" variant="flat" class="toolbar-add-button" @click="addIncome()">Agregar Entrada</v-btn>
      </v-toolbar>
      <div class="table-wrapper">
        <table-income/>
      </div>
    </v-card>
  </div>
</v-container>
</template>
<script>
import FilterIncomeForm from './FilterIncomeForm'
import AddEditIncomeForm from './AddEditIncomeForm'
import IncomeTable from './IncomeTable'
import NotificationDialog from '../Common/NotificationDialog'
import AnalysisForm from './Analysis'

export default {
  name: 'Income',
  components: {
    'filter-form-income': FilterIncomeForm,
    'dialog-form-income': AddEditIncomeForm,
    'table-income': IncomeTable,
    'notification-dialog': NotificationDialog,
    'form-analysis': AnalysisForm
  },
  data: () => ({
    successMsg: ''
  }),
  computed: {
    canCreate () { return this.$store.getters['authModule/hasPermission']('plant.incomes.create') }
  },

  methods: {
    addIncome () {
      this.$store.dispatch('incomeModule/setSelectedItem', this.$store.getters['incomeModule/getDefaultItem'])
      this.$store.dispatch('incomeModule/setDialogActived', true)
    }
  }
}
</script>
